// @flow

/* eslint-disable react/prop-types */

import React from 'react';
import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import Separator from '../../../components/Separator';
import NotesAction from '../../../components/actions/NotesAction';
import AdditionalInfoAction from '../../../components/actions/AdditionalInfoAction';
import ItemHistoryAction from '../../../components/actions/ItemHistoryAction';
import InvoiceHistoryAction from '../../../components/actions/InvoiceHistoryAction';
import SavedOrdersAction from '../../../components/actions/SavedOrdersAction';
import CreateOrderAction from '../../../components/actions/CreateOrderAction';
import { getNotesFieldMapping, getIdFieldMapping } from '../../../utils';
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'
import { DesktopView, MobileView } from '../../../config/mediaQuery';

type Props = {
  minHeight: string,
  onNotesSaved: any => mixed,
  clearCollectionAndResetChangedOrderItems: () => mixed,
  setCollapseLoading?: (isLoading: boolean) => void,
};

const ActionsOrganizerAccounts = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportAction,
    RefreshAction,
    SaveViewAction,
    MultiSortAction,
    currentItem,
    getGlobalDisabledState,
    hasDataToDisplay,
    isOneRowSelected,
    loading,
    onOrderCreated,
    orderCreateStatus,
    clearCollectionAndResetChangedOrderItems,
    clearInternalFilters,
    displayRowMenu,
    displayMenu
  } = props;

  const moduleName = 'accounts';
  const notesFieldMapping = getNotesFieldMapping(moduleName);
  const idFieldMapping = getIdFieldMapping(moduleName);

  const content = currentItem && currentItem[notesFieldMapping];
  const id = currentItem && currentItem[idFieldMapping];

  const exportAction = <ExportAction />;
  const saveViewAction = <SaveViewAction />;
  const copyAction = <CopyAction />;
  const notesAction = <NotesAction
    moduleName={moduleName}
    disabled={
      getGlobalDisabledState() ||
      !hasDataToDisplay ||
      !isOneRowSelected ||
      loading
    }
    notes={content}
    id={id}
    onSave={props.onNotesSaved}
    itemHasContent={!!content}
    fieldName={notesFieldMapping}
  />;
  const itemHistoryAction = <ItemHistoryAction
    disabled={getGlobalDisabledState() || !isOneRowSelected || loading}
    item={currentItem}
    moduleName={moduleName}
  />;
  const invoiceHistoryAction = <InvoiceHistoryAction
    disabled={getGlobalDisabledState() || !isOneRowSelected || loading}
    item={currentItem}
  />;
  const createOrderAction = <CreateOrderAction
    disabled={getGlobalDisabledState() || !isOneRowSelected || loading}
    onOrderCreated={onOrderCreated}
    orderCreateStatus={orderCreateStatus}
    item={currentItem}
    onMutationCompleted={clearCollectionAndResetChangedOrderItems}
  />;
  const additionalInfoAction = <AdditionalInfoAction
    disabled={
      getGlobalDisabledState() ||
      !hasDataToDisplay ||
      !isOneRowSelected ||
      loading
    }
    item={currentItem}
  />;
  return (
    <>
      <DesktopView>
        <Row minHeight={props.minHeight}>
          <ActionsColumn>
            <RefreshAction />
            {exportAction}
          </ActionsColumn>

          <ActionsColumn>
            {copyAction}
            <ColumnsAction />
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            {saveViewAction}
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            {notesAction}

            {additionalInfoAction}
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            {itemHistoryAction}
            {invoiceHistoryAction}
          </ActionsColumn>

          <ActionsColumn>
            <SavedOrdersAction
              disabled={getGlobalDisabledState() || loading}
              item={currentItem}
            />
            {createOrderAction}
          </ActionsColumn>

          <Separator />

          <ActionsColumn>
            <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
          </ActionsColumn>
          
          <ActionsColumn>
            <MultiSortAction />
          </ActionsColumn>
        </Row>
      </DesktopView>
      <MobileView>
        {displayRowMenu &&
          <div className='actions-menu-top-section'>
            <div style={{ fontWeight: 'bold', color: 'black' }}>{currentItem && currentItem.AcctName}</div>
          </div>
        }
        <div className='action-menu-items'>
          <ActionsColumn>
            <table>
              {displayMenu &&
                <tbody>
                  <tr>
                    <td>{exportAction}</td>
                  </tr>
                  <tr>
                    <td>{saveViewAction}</td>
                  </tr>
                </tbody>
              }
              {displayRowMenu &&
                <tbody>
                  <tr>
                    <td>{notesAction}</td>
                    <td>{additionalInfoAction}</td>
                  </tr>
                  <tr>
                    <td>{itemHistoryAction}</td>
                    <td>{invoiceHistoryAction}</td>
                  </tr>
                  <tr>
                    <td>{createOrderAction}</td>
                    <td>{copyAction}</td>
                  </tr>
                </tbody>
              }
            </table>
          </ActionsColumn>
        </div>
      </MobileView>
    </>
  );
};

export default ActionsOrganizerAccounts;
